import { t } from "i18next";

export const submit = (values, props) => {
  const { handleHide, selectedElement, setSelectedValuationParts } = props;

  delete selectedElement.updatedBy;
  delete selectedElement.updatedAt;
  delete selectedElement.uuid;
  delete selectedElement.folders;
  delete selectedElement.notes;

  const elementToAdd = {
    ...selectedElement,
    ...values,
  }

  setSelectedValuationParts((p)=>p.map((el)=>{
    if(el.manufacturerIndex !== elementToAdd.manufacturerIndex)  return el;

    return elementToAdd;
    
  }));
  handleHide();
};

export const validate = (values) => {
  const errors = {};

  if (!values.price) {
    errors.price = t('global:fieldRequired');
  }

  if (!values.quantity) {
    errors.quantity = t('global:fieldRequired');
  }

  return errors;
};
